import { isProjectReportGenerating } from 'shared/helpers/projectStatus';
import { Project } from 'store/api/apiTypes';

export const getReportFetchEligibility = (
  project?: Project | null
): { canFetch: boolean; reason: string } => {
  if (!project) return { canFetch: false, reason: 'no-project' };
  if (!project.domain) return { canFetch: false, reason: 'no-domain' };
  if (isProjectReportGenerating(project))
    return {
      canFetch: true,
      reason: 'reports-generating but polling is active',
    };
  return { canFetch: true, reason: '' };
};

export const shouldFetchReports = (project?: Project | null): boolean => {
  return getReportFetchEligibility(project).canFetch;
};
